import { ChartOptions, TooltipItem } from 'chart.js';

import { IIncidentTypeStats } from 'features/admin/model/IIncidentTypeStats';

import { convertTZ, getFormattedDate } from 'shared/lib/datetime';

const ADMIN_TIME_ZONE = 'Europe/Moscow';
const INTERVAL_MS = 5 * 60 * 1000;

const formatMoscowTime = (date: Date): string => {
    return getFormattedDate(date, { tzString: ADMIN_TIME_ZONE, format: 'HH:mm' });
};

export const getIncidentTypeChartOptions = (stats: IIncidentTypeStats[]): ChartOptions<'bar'> => {
    return {
        responsive: true,
        maintainAspectRatio: false,

        interaction: {
            mode: 'index' as const,
            intersect: false,
        },

        scales: {
            x: {
                stacked: true,
                grid: { display: false },
                ticks: {
                    autoSkip: false,
                    maxRotation: 0,
                    callback: (_value: number | string, index: number) => {
                        const item = stats[index];
                        if (!item) return '';

                        const endDate = new Date(item.date);
                        if (convertTZ(endDate, ADMIN_TIME_ZONE).getMinutes() % 30 !== 0) return '';

                        return formatMoscowTime(endDate);
                    },
                },
            },

            y: {
                stacked: true,
                beginAtZero: true,
                ticks: { precision: 0 },
            },
        },

        plugins: {
            legend: {
                display: true,
                position: 'bottom' as const,
            },

            tooltip: {
                callbacks: {
                    title: (items: TooltipItem<'bar'>[]) => {
                        if (!items.length) return '';

                        const item = stats[items[0].dataIndex];
                        if (!item) return '';

                        const endDate = new Date(item.date);
                        const startDate = new Date(endDate.getTime() - INTERVAL_MS);

                        return `${formatMoscowTime(startDate)} - ${formatMoscowTime(endDate)}`;
                    },

                    label: (ctx: TooltipItem<'bar'>) => {
                        return `${ctx.dataset.label}: ${ctx.parsed.y}`;
                    },
                },
            },
        },
    };
};
